@if (hasImage()) {
<p-avatar [image]="imageUrl()" [size]="size()" shape="circle" />
} @else {
<p-avatar icon="fa-solid fa-user" [size]="size()" shape="circle" style="background-color: white; color: #c46502;" />
}